module.exports = __webpack_public_path__ + "static/media/1.5de73b7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80288/1.jpg
// module id = 778
// module chunks = 0